import { useCalendarGroupSessions } from "../../../../../../contexts/CalendarGroupSessionsContext";
import CheckboxDropdown from "components/checkbox-dropdown/CheckboxDropdown";
import ColorCheckbox from "../../../color-checkbox/ColorCheckbox";
import messages from "messages";
import { AmplitudePageName, track } from "utils/amplitude";

interface GroupSessionsToggleProps {
  analyticsPageName: AmplitudePageName;
}

const GroupSessionsToggle = ({
  analyticsPageName,
}: GroupSessionsToggleProps) => {
  const { show, setShow } = useCalendarGroupSessions();

  return (
    <CheckboxDropdown
      Label={messages.groupSessions}
      onClick={() => {
        track(analyticsPageName, "group-sessions-toggle", "click");
        setShow(!show);
      }}
      Checkbox={
        <ColorCheckbox
          color={show ? "var(--verified-green)" : "none"}
          backgroundColor={show ? "var(--gentle-green)" : "none"}
          stroke={show ? "var(--gentle-green)" : "var(--gray02)"}
        />
      }
    />
  );
};

export default GroupSessionsToggle;
